<template>
  <div id="box">
    <HeaderView />
    <div class="banner-container">
      <div class="banner-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div class="banner" v-for="(slide, index) in bannerSlides" :key="index">
          <img v-if="slide.image" :src="slide.image" alt="" />
          <video :ref="el => bannerVideos[index] = el" v-else-if="slide.video" :src="slide.video" autoplay muted
            playsinline></video>
          <div>
            <div class="banner-content">
              <div><router-link to="/about#profile" class="banner-title" v-html="slide.title" ></router-link></div>
              <div class="banner-btn" v-if="slide.code">
                <div class="code-btn">{{ slide.code }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-dots">
        <span v-for="(slide, index) in bannerSlides" :key="index" :class="{ active: index === currentIndex }"
          @click="goToSlide(index)"></span>
      </div>
      <!-- <div class="banner-nav prev" @click="prevSlide">&lt;</div>
      <div class="banner-nav next" @click="nextSlide">&gt;</div> -->
    </div>

    <section class="section1">
      <div class="section1-content">
        <div class="wow fadeInDown " data-wow-delay="0" animate-duration='2s'>
          <h2 class="main-products-title mt-2">Main Products</h2>
          <p class="main-products-description">
            Specializing in the fabrication, supply, and related services of monopiles, jackets (HVAC/HVDC/OSP/WTG), pin
            piles, HVACs, HVDCs, marine ranches, floating foundations, transition pieces, cages, wind turbine towers and
            related foundation structural components.
          </p>
        </div>

        <div class="s1-lunbo wow fadeInUp" data-wow-delay="1s">
          <Swiper effect="coverflow" :observer="true" :observeParents="true" :slides-per-view="1.5"
            :slides-per-group="1" :initial-slide="0" :space-between="0" :loop="shouldLoop" :centeredSlides="true"
            :autoplay="{ delay: 8000, disableOnInteraction: false }" :modules="modules" :navigation="{
              prevEl: '.swiper-button-prev2',
              nextEl: '.swiper-button-next2',
            }" :pagination="{ el: '.swiper-pagination-employee', clickable: true }" :coverflow-effect="{
              rotate: 0,
              stretch: 0,
              depth: 0,
              modifier: 1,
              slideShadows: false,
            }" :speed="1200" easing="ease-in-out" class="auto-swiper3 employee-swiper">
            <SwiperSlide v-for="(product, index) in productSlides" :key="product.id">
              <div class="product-slide" @click="goToProducts(product.id)">
                <div class="product-image">
                  <img :src="product.image" :alt="product.alt" />
                  <div class="page-number">
                    <span class="current-page">{{
                      String(index + 1).padStart(2, "0")
                    }}</span>
                    <span class="separator">/</span>
                    <span class="total-pages">{{
                      String(productSlides.length).padStart(2, "0")
                    }}</span>
                  </div>
                </div>
                <div class="product-content">
                  <div class="product-text">
                    <h3 class="product-title">{{ product.title }}</h3>
                    <!-- <p class="product-description">
                      {{ product.description }}
                    </p> -->
                  </div>
                  <div class="product-arrow">
                    <span class="arrow-btn"><svg t="1767580097665" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        p-id="7076" width="25" height="25">
                        <path
                          d="M885.113 489.373L628.338 232.599c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255l203.3 203.3H158.025c-17.036 0-30.846 13.811-30.846 30.846 0 17.036 13.811 30.846 30.846 30.846h628.36L583.084 746.147c-12.497 12.496-12.497 32.758 0 45.255 6.248 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.372l256.775-256.775a31.999 31.999 0 0 0 0-45.254z"
                          fill="#ffffff" p-id="7077"></path>
                      </svg></span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div class="swiper-button-prev2"></div>
          <div class="swiper-button-next2"></div>
        </div>
      </div>
    </section>

    <section class="section2">
      <div class="section2-content container">
        <div class="wow fadeInDown" data-wow-delay="0">
          <h2 class="main-products-title2">
            Fabrication Yards <br />& Factories
          </h2>
        </div>

      </div>
      <div class="map-box wow fadeInRight" data-wow-delay="0s" animate-duration='2s'>
        <div class="map-wrapper">
          <img src="/imgs/home/images/s2-map_03.png" alt="" class="map" />
          <div class="map-labels map-labels-desktop wow fadeInLeft" data-wow-delay="1s" animate-duration='2s'>
            <div v-for="category in categories" :key="category.id" class="map-label"
              :class="[getLabelClass(category.nickname), { active: filterType === category.nickname }]"
              @click="filterLocations(category.nickname)">
              {{ category.name }}
            </div>
          </div>
          <div v-for="(location, index) in mapLocations" :key="location.id" class="map-marker" :class="{
            active: selectedLocation === index,
            ['marker-' + location.type.replace(/\s+/g, '-')]: true,
          }" :data-location-id="location.id" @click="selectLocation(index)" v-show="location.type === filterType">
            <img :src="getMarkerIcon(location.type)" alt="" class="marker-icon" />
          </div>
        </div>
        <div class="map-labels wow fadeInLeft" data-wow-delay="1s" animate-duration='2s'>
          <div v-for="category in categories" :key="category.id" class="map-label"
            :class="[getLabelClass(category.nickname), { active: filterType === category.nickname }]"
            @click="filterLocations(category.nickname)">
            {{ category.name }}
          </div>
        </div>
        <div class="location-info wow fadeInUp" data-wow-delay="0s" @click="goToFabricationByType">
          <div class="location-content">
            <div class="location-ncontent">
              <div class="product-arrow">
                <span class="arrow-btn2"><svg t="1767580097665" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    p-id="7076" width="25" height="25">
                    <path
                      d="M885.113 489.373L628.338 232.599c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255l203.3 203.3H158.025c-17.036 0-30.846 13.811-30.846 30.846 0 17.036 13.811 30.846 30.846 30.846h628.36L583.084 746.147c-12.497 12.496-12.497 32.758 0 45.255 6.248 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.372l256.775-256.775a31.999 31.999 0 0 0 0-45.254z"
                      fill="#ffffff" p-id="7077"></path>
                  </svg></span>
              </div>
              <div class="location-text" v-if="mapLocations[selectedLocation]?.content">
                <h3>{{ mapLocations[selectedLocation].content.title }}</h3>
                <p>{{ mapLocations[selectedLocation].content.description }}</p>
              </div>
            </div>
          </div>
          <div class="location-image" v-if="mapLocations[selectedLocation]?.content?.image">
            <img :src="mapLocations[selectedLocation].content.image" alt="" />
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="container">
        <div class="wow fadeInDown" data-wow-delay="0">
          <h2 class="main-products-title">Project Highlights</h2>
          <p class="main-products-description">
            By leveraging our core competitive strengths, we have contributed to a
            number of landmark wind energy projects globally.
          </p>
        </div>
      </div>
      <div class="section3-content container">
        <div class="accordion wow fadeInUp" data-wow-delay="0.5">
          <div class="accordion-item" v-for="(item, index) in accordionItems" :key="index"
            :class="{ active: activeIndex === index }" @mouseenter="activeIndex = index" @click="goToProjectHighlights">
            <div class="accordion-image">
              <img :src="item.expandedImage" :alt="item.title" />
            </div>
            <div class="accordion-content">
              <div class="accordion-icon">
                <img :src="item.icon" :alt="item.title" />
              </div>
              <h3 class="accordion-title">{{ item.title }}</h3>
              <p class="accordion-desc" v-if="activeIndex === index">
                {{ item.description }}
              </p>
              <div class="banner-btn" v-if="activeIndex === index" @click.stop="goToProjectHighlights">
                <div class="code-btn">{{ item.code }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="s3-brief">
          <div class="brief-item">Nationwide Facilities</div>
          <div class="brief-divider">|</div>
          <div class="brief-item">Advanced Equipment</div>
          <div class="brief-divider">|</div>
          <div class="brief-item">Exquisite Techniques</div>
          <div class="brief-divider">|</div>
          <div class="brief-item">Strict Quality Control</div>
          <div class="brief-divider">|</div>
          <div class="brief-item">Integrated HSEQ Management System</div>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="container">
        <div class="wow fadeInDown" data-wow-delay="0">
          <h2 class="main-products-title2">Corporate News</h2>
        </div>
        <div class="section4-content">
          <div class="news-card wow2 fadeInUp" v-for="(item, index) in newsItems" :key="item.id"
            :data-wow-delay="(index * 0.1) + 's'" @click="goToNewsDetail(item)">
            <div class="news-image" :class="{ 'has-video': item.video }">
              <video v-if="item.video" :src="item.video" autoplay muted loop playsinline
                @click.stop.prevent="openVideoModal(item.video)"></video>
              <img v-else :src="item.image || '/imgs/media/images/irem-img_03.png'" alt="News Image" />
              <div v-if="item.video" class="video-play-overlay" @click.stop.prevent="openVideoModal(item.video)">
                <div class="play-icon">
                  <svg viewBox="0 0 1024 1024" width="48" height="48">
                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" fill="rgba(255,255,255,0.8)"/>
                    <path d="M719.4 499.8L416.8 326.6c-12.8-7.4-28.6 1.8-28.6 16.6v346.4c0 14.8 15.8 24 28.6 16.6l302.6-173.2c12.8-7.4 12.8-25.8 0-33.2z" fill="rgba(255,255,255,0.9)"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="news-content">
              <div class="news-date">
                <img src="/imgs/home/images/icon-date_03.png" alt="Date Icon" />
                <span>{{ item.date }}</span>
              </div>
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-description" v-html="item.description"></p>
              <button class="news-button">{{ item.buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterView />

    <!-- 视频弹窗 -->
    <div v-if="showVideoModal" class="video-modal" @click="closeVideoModal">
      <div class="video-modal-content" @click.stop>
        <button class="video-modal-close" @click="closeVideoModal">×</button>
        <video ref="modalVideo" :src="currentVideoUrl" controls autoplay></video>
      </div>
    </div>
  </div>
</template>

<script>
import WOW from "wow.js";
import "animate.css";
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
import apiServe from "@/services";
import { Swiper, SwiperSlide } from "swiper/vue";
import {
  Pagination,
  Autoplay,
  Navigation,
  EffectCoverflow,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";


export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderView,
    FooterView,
  },
  data() {
    return {
      modules: [Pagination, Autoplay, Navigation, EffectCoverflow],
      currentIndex: 0,
      timer: null,
      isVideoPlaying: false,
      bannerVideos: [], // Array to store video refs
      bannerSlides: [],
      productSlides: [],
      mapLocations: [],
      categories: [],
      selectedLocation: 0,
      filterType: "",
      showVideoModal: false,
      currentVideoUrl: "",
      newsItems: [],
      accordionItems: [
        {
          title: "CTG Dafeng Wind Farm",
          description:
            "Year of Construction: 2024",
          code: "View more",
          expandedImage: "/imgs/home/images/demo/shoufengqin/images/img0_03.png",
          icon: "/imgs/home/images/s3-icon1_03.png",
        },
        {
          title: "Huaneng North Shandong  Peninsula Site L Wind Farm",
          description:
            "Year of Construction: 2025",
          code: "View more",
          expandedImage: "/imgs/home/images/demo/shoufengqin/images/img1_03.png",
          icon: "/imgs/home/images/s3-icon2_03.png",
        },
        {
          title: "Jiangsu Dafeng Longyuan  Sheyang Offshore Wind Farm",
          description:
            "Year of Construction: 2025",
          code: "View more",
          expandedImage: "/imgs/home/images/demo/shoufengqin/images/img2_03.png",
          icon: "/imgs/home/images/s3-icon3_03.png",
        },
        {
          title:
            "Hebei Construction &  Investment Xiangyun Island  250 MW Offshore Wind Farm",
          description:
            "Year of Construction: 2025",
          code: "View more",
          expandedImage: "/imgs/home/images/demo/shoufengqin/images/img3_03.png",
          icon: "/imgs/home/images/s3-icon4_03.png",
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    shouldLoop() {
      return this.productSlides.length >= 5;
    },
  },
  watch: {
    // Watch for changes in currentIndex to restart video playback when switching to video slides
    currentIndex(newIndex) {
      const newSlide = this.bannerSlides[newIndex];
      if (newSlide && newSlide.video) {
        // Restart video playback
        const videoElement = this.bannerVideos[newIndex];
        if (videoElement) {
          // Reset video to the beginning and play
          videoElement.currentTime = 0;
          videoElement.play().catch(error => {
            // Handle any playback errors (e.g., browser autoplay policies)
            console.error('Video play error:', error);
          });
        }
      }
    }
  },
  created() { },
  mounted() {
    this.getIndexData();
    // 初始化 WOW.js 动画
    this.initWOW();
    this.initWOW2();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    getIndexData() {
      apiServe.getIndexData().then(res => {
        console.log(res);
        if (res.data && res.data.banner) {
          this.bannerSlides = res.data.banner.map(item => ({
            image: item.file,
            title: item.title,
            code: "Stock Code: 301155"
          }));
          // 数据加载完成后启动自动轮播
          this.$nextTick(() => {
            this.startAutoPlay();
          });
        }
        if (res.data && res.data.product) {
          this.productSlides = res.data.product.map(item => ({
            id: item.id,
            image: item.image,
            alt: item.title,
            title: item.title,
            description: item.brief
          }));
        }
        if (res.data && res.data.category) {
          this.categories = res.data.category;
          // 默认选中第一个分类
          if (this.categories.length > 0 && !this.filterType) {
            this.filterType = this.categories[0].nickname;
          }
          const locations = [];
          res.data.category.forEach(category => {
            if (category.list && category.list.length > 0) {
              category.list.forEach(item => {
                locations.push({
                  id: item.id,
                  name: item.title,
                  type: category.nickname,
                  content: {
                    title: item.title,
                    description: item.brief || "",
                    image: item.image
                  }
                });
              });
            }
          });
          this.mapLocations = locations;
          // 设置默认选中的位置为当前筛选类型下的第一个
          this.updateSelectedLocation();
        }
        if (res.data && res.data.news) {
          this.newsItems = res.data.news.map(item => ({
            id: item.id,
            video: item.file && item.file.endsWith('.mp4') ? item.file : '',
            image: item.image || (item.file && !item.file.endsWith('.mp4') ? item.file : ''),
            date: item.create_time ? item.create_time.replace(/-/g, '/') : '',
            title: item.titile || item.title,
            description: item.brief,
            buttonText: "View more"
          }));
        }
      })
    },
    // 跳转到新闻详情页
    goToNewsDetail(item) {
      this.$router.push({
        path: '/media-detail',
        query: { id: item.id }
      });
    },
    goToProjectHighlights() {
      this.$router.push('/project-highlights');
    },
    goToFabrication() {
      this.$router.push('/fabrication');
    },
    goToFabricationByType() {
      // 根据当前选中的分类类型决定跳转行为
      if (this.filterType === "Offices") {
        // Offices 不跳转
        return;
      } else if (this.filterType === "Existing Facilities") {
        // Existing Facilities 跳转到 section1
        this.$router.push({ path: '/fabrication', query: { section: 'section1' } });
      } else if (this.filterType === "New Facilities Under Development") {
        // New Facilities Under Development 跳转到 section2
        this.$router.push({ path: '/fabrication', query: { section: 'section2' } });
      }
    },
    goToProducts(productId) {
      this.$router.push({
        path: '/products',
        query: { productId: productId }
      });
    },
    openVideoModal(videoUrl) {
      this.currentVideoUrl = videoUrl;
      this.showVideoModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeVideoModal() {
      this.showVideoModal = false;
      this.currentVideoUrl = "";
      document.body.style.overflow = '';
    },
    // 初始化 WOW.js 动画
    initWOW() {
      new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 200,
        mobile: true,
        live: true,
      }).init();
    },
    initWOW2() {
      new WOW({
        boxClass: "wow2",
        animateClass: "animated",
        offset: 50, // 距离视窗底部50px时触发动画
        mobile: true,
        live: true,
        scrollContainer: null,
        resetAnimation: false, // 避免重复触发动画
        callback: null,
      }).init();
    },
    startAutoPlay() {
      const currentSlide = this.bannerSlides[this.currentIndex];

      // If current slide is a video, wait for it to end before starting auto-play
      if (currentSlide.video) {
        this.isVideoPlaying = true;
        const videoElement = this.bannerVideos[this.currentIndex];
        if (videoElement) {
          // Remove any existing event listeners to avoid duplicates
          videoElement.removeEventListener('ended', this.onVideoEnded);
          // Add event listener for video end
          videoElement.addEventListener('ended', this.onVideoEnded);
        }
      } else {
        // If it's an image, start auto-play immediately
        this.isVideoPlaying = false;
        this.timer = setInterval(() => {
          this.nextSlide();
        }, 5000);
      }
    },
    stopAutoPlay() {
      // Clear the interval if it exists
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      // Remove video event listeners for all videos to avoid memory leaks
      this.bannerVideos.forEach(videoElement => {
        if (videoElement) {
          videoElement.removeEventListener('ended', this.onVideoEnded);
        }
      });
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerSlides.length;
      // Restart auto-play for the new slide
      this.stopAutoPlay();
      this.startAutoPlay();
    },
    onVideoEnded() {
      // Video has ended, start auto-play
      this.isVideoPlaying = false;
      this.nextSlide();
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.bannerSlides.length) %
        this.bannerSlides.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.stopAutoPlay();
      this.startAutoPlay();
    },
    formatPageNumber(id) {
      const current = String(id).padStart(2, "0");
      const total = String(this.productSlides.length).padStart(2, "0");
      return `${current}/${total}`;
    },
    selectLocation(index) {
      this.selectedLocation = index;
    },
    filterLocations(type) {
      this.filterType = type;
      this.updateSelectedLocation();
    },
    updateSelectedLocation() {
      // Find the first location index that matches the current filter type
      const firstIndex = this.mapLocations.findIndex(
        (location) => location.type === this.filterType
      );
      // Update selectedLocation to the first index of the filtered locations
      if (firstIndex !== -1) {
        this.selectedLocation = firstIndex;
      }
    },
    getMarkerIcon(type) {
      // 根据 nickname 返回对应的图标
      const iconMap = {
        "Offices": "/imgs/home/images/icon-location_lan_03.png",
        "Existing Facilities": "/imgs/home/images/icon-location_lv_03.png",
        "New Facilities Under Development": "/imgs/home/images/icon-location_hui_03.png"
      };
      return iconMap[type] || "/imgs/home/images/icon-location_03.png";
    },
    getLabelClass(nickname) {
      // 根据 nickname 返回对应的样式类
      const classMap = {
        "Offices": "label-offices",
        "Existing Facilities": "label-existing",
        "New Facilities Under Development": "label-new"
      };
      return classMap[nickname] || "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/animate.css";
</style>
<style src="../assets/home.css" scoped></style>
<style lang="scss" scoped>
// #hbox {
//   overflow-x: hidden;
//   overflow-y: hidden;
// }

.news-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  max-height: 4.5em;
}

/* 视频弹窗样式 */
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.video-modal-content {
  position: relative;
  width: 90%;
  max-width: 1200px;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-modal-content video {
  width: 100%;
  height: auto;
  max-height: 80vh;
  display: block;
}

.video-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.video-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

// -----------------------------------------------
.mt-2 {
  margin-top: 2rem;
}

// Map marker positions by ID
// 3 Offices (id: 148): Beijing Office (3), Shanghai Office (2), Nantong Office (1)
.map-marker[data-location-id="3"] {
  top: 10%;
  left: 35%;
}

.map-marker[data-location-id="2"] {
  top: 46%;
  left: 47%;
}

.map-marker[data-location-id="1"] {
  top: 39%;
  left: 45%;
}

// 8 Existing Facilities (id: 147): 
// Nantong Qidong Phase I Yard (11), Nantong Tongzhou Bay Yard (10), 
// Nantong Xiaoyangkou (Offshore) Yard (9), Nantong Xiaoyangkou (Wind Energy) Yard (8),
// Yancheng Dafeng (Offshore) Yard (7), Yancheng Dafeng (Haiheng) Yard (6),
// Shandong Weihai Yard (5), Shandong Dongying Factory (4)
.map-marker[data-location-id="11"] {
  top: 40%;
  left: 46%;
}

.map-marker[data-location-id="10"] {
  top: 41%;
  left: 47%;
}

.map-marker[data-location-id="9"] {
  top: 37%;
  left: 45%;
}

.map-marker[data-location-id="8"] {
  top: 42%;
  left: 45%;
}

.map-marker[data-location-id="7"] {
  top: 37%;
  left: 44%;
}

.map-marker[data-location-id="6"] {
  top: 34%;
  left: 44%;
}

.map-marker[data-location-id="5"] {
  top: 19%;
  left: 45%;
}

.map-marker[data-location-id="4"] {
  top: 17%;
  left: 40%;
}

// 4 New Facilities Under Development (id: 146):
// Zhanjiang Yard (15), Wenzhou Yard (14), Nantong Qidong Phase II Yard (13), Yancheng Binhai Yard (12)
.map-marker[data-location-id="15"] {
  top: 95%;
  left: 24%;
}

.map-marker[data-location-id="14"] {
  top: 63%;
  left: 46%;
}

.map-marker[data-location-id="13"] {
  top: 46%;
  left: 48%;
}

.map-marker[data-location-id="12"] {
  top: 29%;
  left: 41%;
}

// 视频播放覆盖层样式
.news-image {
  position: relative;

  &.has-video {
    cursor: pointer;
  }

  .video-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;

    .play-icon {
      transform: scale(0.8);
      transition: transform 0.3s ease;
    }
  }

  &:hover .video-play-overlay {
    opacity: 1;

    .play-icon {
      transform: scale(1);
    }
  }
}
</style>